<div class="overtime-management flex-column d-flex gap-4 " *transloco="let t; prefix: 'overtimeManagement'">
  <div class="row  overtime-management__header align-items-center">
    <div class="col-xl-3 col-12 align-self-center">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
    <div class="col-xl-9">
      <div class="d-flex flex-wrap justify-content-end align-items-center gap-2">
        <div class="toggle">
          <label class="toggle__switch">
            <span class="toggle__label">{{ t('filters.showOnlyRequiresDecision') }}</span>
            <input class="toggle__input" type="checkbox" (change)="toggleDecisionFilter($event)" />
            <span class="toggle__slider"></span>
          </label>
        </div>
        <app-search [placeholder]="t('filters.searchDrivers')" (searchTermUpdated)="onSearchTermUpdate($event)"
          [disabled]="isSearchDisabled"></app-search>
        <app-account-filter [disabled]="false" [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)">
        </app-account-filter>
        <div class="date-filter-wrapper">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            (filterChanged)="onDateFilterChange($event)"></app-date-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="row gx-3 overtime-summary">
    <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
      <app-overtime-activity-summary>
      </app-overtime-activity-summary>
    </div>
    <div class="col-lg-6 col-md-12">
      <app-overtime-hours-summary>
      </app-overtime-hours-summary>
    </div>
  </div>

  <div class="d-flex gap-4 overtime-details">
    @if (!listLoaded) {
      <div class="spinner-overlay">
        <div class="d-flex align-items-center justify-content-center spinner-border"></div>
      </div>
    }
    @if (isSearching && !hasOvertime && listLoaded && detailsLoaded) {
      <div class="d-flex driver-not-found-container">
        <div class="no-drivers-icon">
          <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
        </div>
        <p class="driver-not-found-message">{{ 'driverInformation.driverNotFound' | transloco }}</p>
      </div>
    }
    @if (!hasOvertime && !isSearching && listLoaded) {
      <div class="d-flex justify-content-center align-items-center no-drivers-container">
        <h2 class="no-drivers-title">{{ t('empty.title') }}</h2>
        <div class="no-drivers-icon">
          <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
        </div>
        <p class="no-drivers-message">{{ t('empty.message') }}</p>
      </div>
    }
    <div class="col-auto overtime-details__list" [ngClass]="{'d-none': !listLoaded || !hasOvertime }">
      <app-overtime-driver-list [showOnlyRequiresDecision]="showOnlyRequiresDecision"
        (loaded)="listLoaded = $event"></app-overtime-driver-list>
    </div>
    <div class="flex-grow-1 overtime-details__content" [ngClass]="{'d-none': !listLoaded || !hasOvertime }">
      <app-overtime-driver-details (loaded)="detailsLoaded = $event"></app-overtime-driver-details>
    </div>
  </div>
</div>